import { action, computed, makeObservable, observable } from 'mobx';
import { FullAgency } from 'types/aaaService';

export interface ParentStore {
  allSponsorAgencies: FullAgency[];
  getInitialData(): Promise<void>;
}

interface CreationParams {
  getAllSponsorAgencies: () => FullAgency[];
}

export class SearchAgencyDelegate {
  private _getAllSponsorAgencies: () => FullAgency[];
  private _filteredSponsorAgencies: FullAgency[] = [];

  public get allSponsorAgencies(): FullAgency[] {
    return this._getAllSponsorAgencies();
  }

  public get filteredSponsorAgencies(): FullAgency[] {
    return this._filteredSponsorAgencies;
  }

  /**
   * Searches for agencies based on the provided search value within the available agency collection.
   * Updates array with matching agencies.
   * */
  public searchAgencyByName(searchValue: string): void {
    this._filteredSponsorAgencies = this.allSponsorAgencies.filter((agency) =>
      agency.name.toLowerCase().includes(searchValue.toLowerCase()),
    );
  }

  public resetSearchValue(): void {
    this._filteredSponsorAgencies = [];
  }

  constructor({ getAllSponsorAgencies }: CreationParams) {
    this._getAllSponsorAgencies = getAllSponsorAgencies;

    makeObservable<SearchAgencyDelegate, '_filteredSponsorAgencies'>(this, {
      _filteredSponsorAgencies: observable,
      filteredSponsorAgencies: computed,
      allSponsorAgencies: computed,
      searchAgencyByName: action.bound,
      resetSearchValue: action.bound,
    });
  }
}
